import React from "react";
import { Typography, Button } from "@mui/material";
import { Box, } from "@mui/system";
import FeatureSection from "./FeatureSection";
// import FirstCard from "./FirstCard";
// import Second from "./SecondCard";
// import ThirdCard from "./ThirdCard";
// import ForthCard from "./FourthCard";
// import FifthCard from "./FifthCard";
import { Link } from "react-router-dom";

import Handsake from "../../component/Handsake";
import useTracking from "../../hooks/useTracking";

const BecomePartner = () => {

 const { ref, handleClick } = useTracking("BecomePartner");
  
  return (
    <>
       <Box 
       ref={ref} 
      container spacing={2} sx={{ padding: "20px" }}>
        <img
          src="/img1/Hero.png"
          alt="Download on the App Store"
          width="100%"
          height="100%"

          style={{
            cursor: "pointer",
            maxHeight: "500px", // ✅ Limit max height
            width: "100%",
          }}

        />
      </Box>

      <Box sx={{ px: { xs: "20px", md: "90px" }, }}>
        <Typography
          variant="h3"
          sx={{
            fontSize: { xs: "28px", sm: "34px", md: "48px" },
            fontWeight: 600,
            mt: { xs: "30px", sm: "0px" },
            color: '#374D91'
          }}
        >
          Partner with Us
        </Typography>
        <Typography sx={{ color: "#000000B2", mt: "10px", textAlign: { xs: "left", sm: "center", md: "center" }, lineHeight: "28px", fontSize: { xs: "14px", sm: "18px" }, fontFamily: 'Poppins' }}>
          Changes in become a partner Join us in revolutionizing the Lebanese market by becoming a valued partner! Our platform bridges the gap between the UAE and Lebanon, offering customers access to a curated selection of products from Dubai’s top retailers. By partnering with us, you’ll gain exposure to a growing audience in Lebanon, seamless logistics for cross-border shipping, and a collaborative approach to expanding your reach. Together, we can bring the best of the UAE to Lebanon while creating new opportunities for growth and success. Let’s build something extraordinary—partner with us today!
        </Typography>

        <Link to="/contact" onClick={() => handleClick("Contact_button_clicked")}>
          {/* <Button variant="contained" sx={{ marginTop: 2, bgcolor: "#374d91", color: "#f7ef6d", }}>
            Get Started
          </Button> */}

          <Button
            variant="contained"
            sx={{
              bgcolor: "#374d91",
              color: "#f7ef6d",
              borderRadius: "50px",
              padding: "10px 20px",
              fontWeight: 600,
              fontSize: "14px",
              fontFamily: "Poppins",
               marginTop: 2,
               textTransform: "none",
            }}
          >
            Become a partner
          </Button>
        </Link>

      </Box>

      <Handsake />
      <FeatureSection />
    </>
  );
};

export default BecomePartner;
